import { Box, Grid, styled, Typography } from "@mui/material";
import React, { useState } from "react";
import EastIcon from "@mui/icons-material/East";
import { transform } from "framer-motion";
import { Link } from "react-router-dom";
const TextWrapp = styled((props) => <Box {...props}>{props.children}</Box>)(
  ({ theme }) => ({
    position: "absolute",
    top: "5%",
    left: "5%",
    display: "flex",
    flexDirection: "column",
    gap: 8,
    zIndex: 2,
  })
);
const CatHeader = styled((props) => (
  <Typography variant="h5" {...props}>
    {props.children}
  </Typography>
))(({ theme }) => ({
  // fontSize:'14px',
  fontFamily: "Lato, sans-serif",
  lineHeight: "25px",
  fontWeight: 400,
  textTransform: "capitalize",
  letterSpacing: 3,
}));
const SubHeader = styled((props) => (
  <Typography variant="button" {...props}>
    shop now{" "}
    <EastIcon
      className="shopNowArrow"
      sx={{ fontSize: "1rem", verticalAlign: "middle" }}
    />
  </Typography>
))(({ theme, hover }) => ({
  fontFamily: "Libre Baskerville",
  fontStyle: "italic",
  lineHeight: "25px",
  fontWeight: 300,
  color: "#AEAFAE",
  textTransform: "capitalize",
  "& .shopNowArrow": {
    transition: "0.8s",
    ...(hover && { transform: "translate(10px,0)" }),
  },
}));
const Category = ({ title, img, link }) => {
  const [hover, setHover] = useState(false);
  return (
    <Link to={link}>
      <Box
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        sx={{ position: "relative", transition: ".8s opacity" }}
      >
        <TextWrapp>
          <CatHeader>{title}</CatHeader>
          <SubHeader hover={hover} />
        </TextWrapp>
        <Box
          sx={{
            height: { xs: "300px", sm: "100%", md: "100%", lg: "100%" },
            overflow: "hidden",
          }}
        >
          <img
            className="cat_img"
            src={img}
            width="100%"
            height="100%"
            style={{
              objectFit: "cover",
              transition: "0.8s",
              ...(hover && { transform: "scale(1.2)" }),
            }}
            alt={title}
          />
        </Box>
      </Box>
    </Link>
  );
};

export default Category;
